import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_REQUEST = `${PhotoCapture.PHOTO_CAPTURE}_IMAGE_DETAIL_OCR_REQUEST`;
export const PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_IMAGE_DETAIL_OCR_SUCCESS`;
export const PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_FAILURE = `${PhotoCapture.PHOTO_CAPTURE}_IMAGE_DETAIL_OCR_FAILURE`;
export const PHOTO_CAPTURE_INTELLIGENT_UPDATE_OCR = `${PhotoCapture.PHOTO_CAPTURE}_IMAGE_DETAIL_UPDATE_OCR`;
export const photoCaptureIntelligentOCRAction = () => ({
    type: PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_REQUEST,
    payload: null
});
export const photoCaptureIntelligentImageDetailOCRSuccessAction = (photoCaptureImageOCRData, questionSubType) => {
    return {
        type: PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_SUCCESS,
        payload: { photoCaptureImageOCRData, questionSubType }
    };
};
export const photoCaptureIntelligentImageDetailOCRFailureAction = failureMessage => ({
    type: PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_FAILURE,
    payload: { failureMessage }
});
export const photoCaptureIntelligentUpdateOCRInfo = (ocrInfo) => {
    return {
        type: PHOTO_CAPTURE_INTELLIGENT_UPDATE_OCR,
        payload: { ocrInfo }
    };
};
//# sourceMappingURL=photoCaptureIntelligentImageDetailOCRAction.js.map